import { useState } from 'react';
import { Circle, Group, Rect, Text } from 'react-konva';
import { DOT_OPACITY, PAD_L, PAD_T } from './constants';

type LegendItem = {
    id: string;
    name: string;
    color: string;
    deviation: number;
    diDiff: number;
    x: number;
    y: number;
};

export type LegendProps = {
    items: ReadonlyArray<LegendItem>;
    onRowHover: (item: LegendItem) => void;
    onRowHoverEnd: (item: LegendItem) => void;
};

export function Legend({ items, onRowHover, onRowHoverEnd }: LegendProps) {
    const [hoveredId, setHoveredId] = useState<string | null>(null);

    const startX = 4;
    const dotR = 8;
    const textX = dotR * 2 + 6;
    const textW = PAD_L - textX - startX;
    const rowH = 24;
    const fontSize = 12;

    return items.map((item, i) => (
        <Group key={item.name} x={startX} y={PAD_T + i * rowH}>
            <Circle x={dotR} y={dotR} radius={dotR} fill={item.color} opacity={DOT_OPACITY} />
            <Text
                x={textX}
                y={-fontSize / 2}
                width={textW}
                height={rowH}
                text={item.name}
                fontSize={fontSize}
                fontStyle={hoveredId === item.id ? 'bold' : 'normal'}
                fill="#444"
                verticalAlign="middle"
            />
            {/* Invisible hit area for the full row */}
            <Rect
                width={textX + textW}
                height={rowH}
                fill="transparent"
                onMouseEnter={(_e) => {
                    setHoveredId(item.id);
                    onRowHover(item);
                }}
                onMouseLeave={(_e) => {
                    setHoveredId(null);
                    onRowHoverEnd(item);
                }}
            />
        </Group>
    ));
}
